export const GET_CONTENTS_START = 'GET_CONTENTS_START';
export const GET_CONTENTS_SUCCESS = 'GET_CONTENTS_SUCCESS';
export const GET_CONTENTS_FAIL = 'GET_CONTENTS_FAIL';
export const GET_CONTENTS_RESET = 'GET_CONTENTS_RESET';
